export default __webpack_public_path__ + "static/media/icon.5a17d36f.png";